export default "__VITE_ASSET__Dp2_Zihg__"